import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import * as api from '../../apiCalls'
import {contextCheckingStatus, paymentMethod as paymentMethodType, promoEditorMode, purchaseStep, UNLIMITED_USERS_COUNT} from '../../constants'
import {
    getCompanyInfo,
    getNewProductUrl,
    getPaymentMethod,
    getPoNumber,
    getProcessId,
    getPromoCode,
    getPurchaseStepNumber,
    getPurchaseSteps,
    getVatNumber,
    haveSavedCard
} from './selectors'
import {
    getPurchasePeriod,
    getStartDate,
    getUsersCount as getPurchaseUsersCount,
    isSelectUnlimitedUsers as isUnlimitedSelectedInPurchase
} from '../chooser/selectors'
import {
    getCurrentLicenseId,
    getUsersCount as getAddUsersCount,
    isSelectUnlimitedUsers as isUnlimitedSelectedInAddUsers
} from '../licenseList/addUsers/selectors'
import {getAddress, getCity, getCountry, getEditable, getHolderName, getState, getZip, isBillingAddressEntered, isNeedToSaveCard} from '../creditCard/selectors'
import {setAddressFormOpen, setBillingAddress, setCardInfoFromData, setEditable} from '../creditCard/actions'
import {getLicensedToInfo, getSavedCardInfo} from '../../selectors'
import stripe from '../../stripe'

export const setProcessId = createAction(ActionTypes.PROCESS_ID_SET)
export const setPurchaseInfo = createAction(ActionTypes.PURCHASE_INFO_SET)
export const setPurchaseStepNumber = createAction(ActionTypes.PURCHASE_STEP_NUMBER_SET)
export const setPurchaseStrategyType = createAction(ActionTypes.PURCHASE_STRATEGY_TYPE_SET)
export const setCompanyInfo = createAction(ActionTypes.COMPANY_INFO_SET)
export const setAgreementsConfirmed = createAction(ActionTypes.AGREEMENTS_CONFIRMED_SET)

export const setInitialHostingZone = createAction(ActionTypes.INITIAL_HOSTING_ZONE_SET)
export const setHostingZone = createAction(ActionTypes.HOSTING_ZONE_SET)
export const setLockedZone = createAction(ActionTypes.LOCKED_ZONE_SET)
export const setContext = createAction(ActionTypes.CONTEXT_SET)
export const setContextInvalid = createAction(ActionTypes.CONTEXT_INVALID)
export const setContextCheckingStatus = createAction(ActionTypes.CONTEXT_CHECKING_STATUS_SET)
export const setPromoEditorMode = createAction(ActionTypes.PROMO_EDITOR_MODE_SET)
export const setPromoCode = createAction(ActionTypes.PROMO_CODE_SET)
export const setPromoInvalid = createAction(ActionTypes.PROMO_INVALID_SET)
export const setPrices = createAction(ActionTypes.PRICES_SET)
export const setTransferHostingZoneProcessing = createAction(ActionTypes.TRANSFER_HOSTING_ZONE_PROCESSING_SET)
export const setDocumentUrls = createAction(ActionTypes.DOCUMENT_URLS_SET)
export const resetPurchaseState = createAction(ActionTypes.PURCHASE_STATE_RESET)
export const startLoading = createAction(ActionTypes.LOADING_START)
export const finishLoading = createAction(ActionTypes.LOADING_FINISH)
export const setVatNumber = createAction(ActionTypes.VAT_NUMBER_SET)
export const setPoNumber = createAction(ActionTypes.PO_NUMBER_SET)

export const setPaymentMethod = (paymentMethod) => (dispatch, getState) => {
    const state = getState()
    const processId = getProcessId(state)
    dispatch(startLoading())
    api.setPaymentMethod(processId, paymentMethod)
       .then((result) => {
           dispatch(setPurchaseInfo(result))
           dispatch(finishLoading())
       })
       .catch((error) => {
           console.log(error)
           dispatch(finishLoading())
       })
}

export const setNextPurchaseStepNumber = () => (dispatch, getState) => {
    const state = getState()
    const purchaseStepNumber = getPurchaseStepNumber(state)
    const steps = getPurchaseSteps(state)
    if (purchaseStepNumber < steps.length) {
        dispatch(setPurchaseStepNumber(purchaseStepNumber + 1))
    }
}

export const setPrevPurchaseStepNumber = () => (dispatch, getState) => {
    const purchaseStepNumber = getPurchaseStepNumber(getState())
    if (purchaseStepNumber > 1) {
        dispatch(setPurchaseStepNumber(purchaseStepNumber - 1))
    }
}

export const startAddUsersProcess = (successCallback = () => {}) => (dispatch, getState) => {
    const state = getState()
    const additionalUsersCount = isUnlimitedSelectedInAddUsers(state) ? UNLIMITED_USERS_COUNT : getAddUsersCount(state)
    const licenseId = getCurrentLicenseId(state)
    dispatch(startLoading())
    api.startAddUsers(licenseId, additionalUsersCount)
       .then((result) => {
           dispatch(setPurchaseInfo(result))
           successCallback()
           dispatch(setNextPurchaseStepNumber())
           dispatch(finishLoading())
       })
       .catch((error) => {
           dispatch(finishLoading())
       })
}

export const startPurchaseProcess = (successCallback = () => {}) => (dispatch, getState) => {
    const state = getState()
    const usersCount = isUnlimitedSelectedInPurchase(state) ? UNLIMITED_USERS_COUNT : getPurchaseUsersCount(state)
    const period = getPurchasePeriod(state)
    const startDate = getStartDate(state)
    dispatch(startLoading())
    api.startPurchase(usersCount, period, startDate)
       .then((result) => {
           dispatch(setPurchaseInfo(result))

           successCallback()
           dispatch(setNextPurchaseStepNumber())
           dispatch(finishLoading())
       })
       .catch((error) => {
           dispatch(finishLoading())
       })
}

export const startGetFreeProcess = (successCallback = () => {}) => (dispatch) => {
    dispatch(startLoading())
    api.startGetFree()
       .then((result) => {
           dispatch(setPurchaseInfo(result))

           successCallback()
           dispatch(setNextPurchaseStepNumber())
           dispatch(finishLoading())
       })
       .catch((error) => {
           dispatch(finishLoading())
       })
}

export const sendCompanyInfo = () => (dispatch, getState) => {
    const state = getState()
    dispatch(startLoading())
    api.setCompanyInfo(getProcessId(state), getCompanyInfo(state))
       .then((result) => {
           dispatch(setPurchaseInfo(result))
           dispatch(setNextPurchaseStepNumber())
           dispatch(finishLoading())
       })
       .catch((error) => {
           //TODO add error handling
           console.log(error)
           dispatch(finishLoading())
       })
}

export const getFreeLicense = () => (dispatch, getState) => {
    const state = getState()
    dispatch(startLoading())
    api.confirmPurchase(getProcessId(state))
       .then(() => {
           dispatch(checkProcessStatus())
       })
       .catch((error) => {
           dispatch(finishLoading())
       })
}

function purchase(state, token, needToSaveCard, vatNumber, poNumber, currentPaymentMethod, dispatch) {
    dispatch(startLoading())
    api.confirmPurchaseWithPaymentDetails(getProcessId(state), {
        token,
        needToSaveCard,
        vatNumber,
        poNumber
    })
       .then((result) => {
           if (currentPaymentMethod === paymentMethodType.CC) {
               dispatch(checkProcessStatus())
           } else {
               dispatch(finishLoading())
               dispatch(setPurchaseInfo(result))
               dispatch(setNextPurchaseStepNumber())
           }
       })
       .catch((error) => {
           dispatch(finishLoading())
       })
}

function createStripeToken(field, state) {
    let holderName = getHolderName(state)
    let address = getAddress(state)
    let city = getCity(state)
    let zip = getZip(state)
    let country = getCountry(state)
    let region = getState(state)

    if (!isBillingAddressEntered(state)) {
        const companyInfo = getCompanyInfo(state)
        address = companyInfo.address
        city = companyInfo.city
        zip = companyInfo.zip
        country = companyInfo.country
        region = companyInfo.state
    }

    return stripe.createToken(field, {
        name: holderName,
        address_line1: address,
        address_city: city,
        address_country: country,
        address_zip: zip,
        address_state: region,
    })
}

export const purchaseLicense = (stripeElements) => (dispatch, getState) => {
    const state = getState()

    const currentPaymentMethod = getPaymentMethod(state)
    const needToSaveCard = isNeedToSaveCard(state)
    const vatNumber = getVatNumber(state)
    const poNumber = getPoNumber(state)

    const isCreditCardInEditableState = getEditable(state)
    const isHaveSavedCard = haveSavedCard(state)

    dispatch(startLoading())
    if (currentPaymentMethod === paymentMethodType.CC
        && (!isHaveSavedCard || isCreditCardInEditableState)) {
        createStripeToken(stripeElements, state)
            .then((result) => {
                if (result.error) {
                    alert(result.error.message)
                    dispatch(finishLoading())
                } else {
                    purchase(state,
                        result.token.id,
                        needToSaveCard,
                        vatNumber,
                        poNumber,
                        currentPaymentMethod,
                        dispatch)
                }
            })
            .catch((error) => {
                alert(error)
                dispatch(finishLoading())
            })
    } else {
        purchase(state,
            '',
            needToSaveCard,
            vatNumber,
            poNumber,
            currentPaymentMethod,
            dispatch)
    }
}

export const changeContext = (value) => (dispatch, getState) => {
    dispatch(setContext(value))

    //checks that string contain only latin letters, digits, and hyphens, and necessarily include at least one latin letter
    const contextValidRegexp = /^(?=.*[a-z].*)[a-z0-9-]{1,25}$/i
    if (value && contextValidRegexp.test(value)) {
        dispatch(setContextCheckingStatus(contextCheckingStatus.IN_PROGRESS))
        api.setNewContext(getProcessId(getState()), value)
           .then((result) => {
               dispatch(setContextCheckingStatus(contextCheckingStatus.COMPLETED))
               dispatch(setPurchaseInfo(result))
           })
           .catch((error) => {
               //TODO add error handling
               console.log(error)
           })
    } else {
        dispatch(setContextInvalid(true))
    }
}

export const changeHostingZone = (value) => (dispatch, getState) => {
    dispatch(setHostingZone(value))
    dispatch(startLoading())
    api.setNewSegment(getProcessId(getState()), value)
       .then((result) => {
           dispatch(setHostingZone(result.variables.newSegment))
           dispatch(finishLoading())
       })
       .catch((error) => {
           //TODO add error handling
           console.log(error)
           dispatch(finishLoading())
       })
}

export const applyPromoCode = () => (dispatch, getState) => {
    const code = getPromoCode(getState())
    dispatch(startLoading())
    api.setPromoCode(getProcessId(getState()), code)
       .then((result) => {
           if (result.variables.promoDiscountAmount !== null) {
               dispatch(setPromoEditorMode(promoEditorMode.REMOVE))
           } else {
               dispatch(setPromoInvalid(true))
           }
           dispatch(setPrices(result))
           dispatch(finishLoading())
       })
       .catch((error) => {
           dispatch(finishLoading())
       })
}

export const removePromoCode = () => (dispatch, getState) => {
    dispatch(startLoading())
    api.setPromoCode(getProcessId(getState()), null)
       .then((result) => {
           dispatch(setPrices(result))
           dispatch(setPromoCode(''))
           dispatch(finishLoading())
       })
       .catch((error) => {
           dispatch(finishLoading())
       })
}

export const switchToFreeVersion = () => (dispatch) => {
    dispatch(startLoading())
    api.switchToFreeVersion()
       .then((result) => {
           dispatch(setPurchaseInfo(result))
           dispatch(checkProcessStatus())
       })
       .catch((error) => {
           dispatch(finishLoading())
       })
}

export const checkProcessStatus = () => (dispatch, getState) => {
    api.checkProcessStatus(getProcessId(getState()))
       .then((result) => {
           if (result.completed) {
               dispatch(finishLoading())
               dispatch(setPurchaseInfo(result))
               dispatch(setNextPurchaseStepNumber())
           } else if (result.incidentMessage !== null) {
               dispatch(finishLoading())
               dispatch(setPurchaseInfo(result))
               alert(result.incidentMessage)
           } else {
               setTimeout(() => dispatch(checkProcessStatus()), 2000)
           }
       })
       .catch((error) => {
           console.log(error)
           dispatch(finishLoading())
       })
}

export const preparePaymentStep = () => (dispatch, getState) => {
    const state = getState()
    const cardInfo = getSavedCardInfo(state)

    dispatch(setAddressFormOpen(false))

    if (cardInfo !== null) {
        dispatch(setEditable(false))
        dispatch(setCardInfoFromData(cardInfo))
    } else {
        const companyInfo = getCompanyInfo(state)
        dispatch(setBillingAddress(companyInfo !== null ? companyInfo : getLicensedToInfo(state)))
    }

    const paymentMethod = getPaymentMethod(state)
    if (paymentMethod !== null) {
        dispatch(setPaymentMethod(paymentMethod))
    }
}

export const closePurchasePopup = () => (dispatch, getState) => {
    const state = getState()
    const currentPurchaseStep = getPurchaseSteps(state)[getPurchaseStepNumber(state) - 1]
    if (currentPurchaseStep === purchaseStep.SUCCESS) {
        const newProductUrl = getNewProductUrl(state)
        if (newProductUrl) {
            location.href = newProductUrl + '/administration/manage_licenses.do'
        } else {
            location.reload()
        }
    } else {
        dispatch(resetPurchaseState())
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/actions.js